// Ruta Protegida
// RecomiendaT - Sistema de recomendaciones

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  // Esperar a que termine la verificación de autenticación
  if (loading) {
    return null; // No mostrar nada mientras se verifica
  }

  // Redirigir al login si no está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Mostrar el contenido protegido si está autenticado
  return children;
}
